import { render, staticRenderFns } from "./chat-hero.vue?vue&type=template&id=7c051c34&scoped=true&"
import script from "./chat-hero.vue?vue&type=script&lang=js&"
export * from "./chat-hero.vue?vue&type=script&lang=js&"
import style0 from "./chat-hero.vue?vue&type=style&index=0&id=7c051c34&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c051c34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c051c34')) {
      api.createRecord('7c051c34', component.options)
    } else {
      api.reload('7c051c34', component.options)
    }
    module.hot.accept("./chat-hero.vue?vue&type=template&id=7c051c34&scoped=true&", function () {
      api.rerender('7c051c34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/chat-hero/chat-hero.vue"
export default component.exports